import { useMutation } from '@apollo/client';
import { REMOVE_REPLY } from '../../graphql/reply-mutations';

export default function useDeleteReply() {
    const [deleteReply, { loading }] = useMutation(REMOVE_REPLY);
    return { deleteReply, loading };
}
